module.exports = __webpack_public_path__ + "jobs-2ec46bc8/free-cover-3afb766bab04848423d6efdb4f226321.svg";